<template>
  <v-container
    fluid
    class="pa-0"
    style="min-height: 100%; display: flex; flex-direction: column; justify-content: space-between;"
  >
    <v-container
      fluid
      :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-4'"
      class="pt-0"
      style
    >
      <v-row dense style="justify-content: center">
        <v-col cols="12" v-if="showBanners && banners.length > 0">
          <v-card :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : 'ma-2'">
            <v-carousel
              interval="4000"
              progress
              cycle
              :hide-delimiters="true"
              height="auto"
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(banner, i) in banners"
                :key="i"
                :src="banner.src"
                :lazy-src="emptyJpg"
                eager
              ></v-carousel-item>
            </v-carousel>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          v-if="
            !($auth.user && $auth.user.tipo === 'fornecedor') &&
              novidades &&
              produtos &&
              produtos.data &&
              produtos.data.length > 0 &&
              $vuetify.breakpoint.xsOnly
          "
        >
          <div
            style="font-size: 24px"
            :class="$vuetify.breakpoint.xsOnly ? 'mx-1 mt-0' : 'mx-2 mt-0'"
          >
            Novidades
          </div>
        </v-col>

        <v-col
          v-for="produto in produtos.data"
          :key="produto.id"
          cols="6"
          lg="2"
          md="4"
          sm="6"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : 'ma-2'"
                :elevation="hover ? 18 : 2"
                :style="
                  'cursor: pointer; transition: all 0.3s ease;' +
                    (hover ? 'transform: scale(1.1); z-index: 1' : '')
                "
              >
                <v-img
                  :src="produto.fotos[0]"
                  class="white--text align-end"
                  :gradient="
                    !hover ? 'to bottom, rgba(0,0,0,0.0), rgba(0,0,0,.2)' : ''
                  "
                  @click="exibirDetalhe(produto)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>

                  <v-card-title
                    v-text="produto.descricao"
                    class="px-3 py-1"
                    :style="
                      hover
                        ? 'background-color: rgba(0,0,0,.6); font-size: 1rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;'
                        : 'font-size: 1rem; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block;'
                    "
                  ></v-card-title>
                </v-img>

                <v-card-actions>
                  <v-chip
                    label
                    color="#FFD300"
                    text-color="black"
                    style="cursor: pointer"
                  >
                    <strong>R$ {{ produto.valor | valorBR }}</strong>
                  </v-chip>
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="
                      $auth.user.tipo === 'cliente' ||
                        !$auth.user.tipo ||
                        $auth.user.tipo === 'representante' ||
                        ($auth.user.tipo === 'fornecedor' &&
                          $store.state.rodadaSetada &&
                          $store.state.rodada.permitir_pedidos)
                    "
                    icon
                    @click="showGrade(produto)"
                  >
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>

      <div
        v-if="totalProdutos > 0"
        class="py-4"
        style="font-size: 16px; width: 100%; text-align: center"
      >
        {{ totalProdutos }} produtos encontrado{{
          totalProdutos > 1 ? "s" : ""
        }}
      </div>
      <div
        v-else
        class="py-4"
        style="font-size: 24px; height: 100px; display: flex; align-items: center; justify-content: center;"
      >
        Nenhum produto encontrado :(
      </div>

      <v-container v-if="totalProdutos > 0" fluid class="py-4">
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="7"
          @input="goToPage"
        ></v-pagination>
      </v-container>
    </v-container>

    <v-container fluid :class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-6'">
      <div style="font-size: 24px">Categorias</div>
      <v-row style="justify-content: center">
        <v-col
          v-for="categoria in $store.state.categorias"
          :key="categoria.id"
          cols="12"
          sm="6"
          md="4"
          lg="2"
          style="justify-content: center; display: flex"
          :class="$vuetify.breakpoint.xsOnly ? 'pa-2' : 'pa-3'"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <v-chip
                class="px-3 py-2"
                x-large
                label
                :color="hover ? 'lightgrey black--text' : 'white black--text'"
                :style="
                  'cursor: pointer; width: 100%; transition: all 0.3s ease;' +
                    (hover ? 'transform: scale(1.1); z-index: 1' : '')
                "
                @click="filtrarCategoria(categoria.id)"
              >
                <img
                  :src="categoria.src"
                  style="height: 36px !important;width: 36px !important"
                />
                <span
                  class="pa-2 pl-3"
                  style="white-space: pre-wrap; overflow: hidden; text-overflow: ellipsis"
                  >{{ categoria.nome }}</span
                >
              </v-chip>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <v-footer dark padless style="display: block">
      <v-card
        flat
        tile
        color="black lighten-1"
        class="lighten-1 white--text text-center"
      >
        <v-card-text>
          <v-btn class="mx-4 white--text" icon @click="openInstagram">
            <v-icon size="24px">mdi-instagram</v-icon>
          </v-btn>
          <v-btn class="mx-4 white--text" icon @click="openFacebook">
            <v-icon size="24px">mdi-facebook</v-icon>
          </v-btn>
          <v-btn class="mx-4 white--text" icon @click="openTwitter">
            <v-icon size="24px">mdi-twitter</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="white--text pt-0"
          >Encontre-nos nas principais redes sociais e remodele seus negócios
          com a gente! ;)</v-card-text
        >

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} —
          <strong>Anron Software &#169;</strong>
        </v-card-text>
      </v-card>
    </v-footer>

    <detalhe-produto :produto="produto" ref="detalheProduto" />

    <grade ref="grade" idWindow="c" />

    <waiting :show="overlayFiltro"></waiting>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import DetalheProduto from "./DetalheProduto.vue";
import Grade from "./Grade.vue";
import ServiceProdutos from "@/services/produtos.js";
import ServiceBanners from "@/services/banners.js";

export default {
  components: {
    DetalheProduto,
    Grade,
  },
  name: "loja",
  data: () => ({
    emptyJpg: `data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////2wBDAf//////////////////////////////////////////////////////////////////////////////////////wAARCAPoC7gDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK${"A".repeat(
      23688
    )}//2Q==`,
    page: 1,
    totalPages: 1,
    totalProdutos: 0,
    produto: {},
    produtos: [],
    showBanners: true,
    novidades: true,
    overlayFiltro: false,
    filtro: {
      termoPesquisa: "",
      categorias: [],
      filtrarValores: false,
      valorInicial: 0,
      valorFinal: 0,
      pagina: null,
      ordenacao: 0,
    },
    banners: [],
  }),
  created() {
    this.getCategorias();
    this.getProdutos();
    this.getBanners();
  },
  mounted() {
    if (this.$route.params.produto) {
      this.buscarProdutoId(this.$route.params.produto);
    }
  },
  methods: {
    openInstagram() {
      window.open("https://www.instagram.com/namodacomvc.oficial", "_blank");
    },
    openFacebook() {
      window.open("https://www.facebook.com/namoda.comvc.75", "_blank");
    },
    openTwitter() {
      window.open("https://twitter.com/namodacomvc", "_blank");
    },
    async buscarProdutoId(produto_id) {
      const { data: dataPro } = await ServiceProdutos.buscarPorId([produto_id]);

      this.exibirDetalhe(dataPro.produtos[0]);
    },
    goToPage(page) {
      this.filtro.pagina = page;
      this.showBanners = false;
      this.getProdutos();
    },
    filtrarCategoria(categoria) {
      this.filtro.categorias = [categoria];
      this.filtro.filtrarValores = false;
      this.filtro.valorInicial = 0;
      this.filtro.valorFinal = 0;
      this.filtro.termoPesquisa = "";
      this.filtro.ordenacao = 0;
      this.showBanners = false;
      this.novidades = false;
      this.filtro.pagina = null;
      this.$store.commit("setFiltro", { ...this.filtro });
    },
    showGrade(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.grade.abrir(this.produto);
    },
    exibirDetalhe(produto_selecionado) {
      this.produto = this.clone(produto_selecionado);
      this.$refs.detalheProduto.abrir();
    },
    async getBanners() {
      let tipo = "Clientes";
      if (this.$auth.user.tipo === "fornecedor") {
        tipo = "Fornecedores";
      }
      if (this.$auth.user.tipo === "representante") {
        tipo = "Representantes";
      }
      try {
        const { data } = await ServiceBanners.ativos(tipo);
        if (data) {
          this.banners = data.banners.map((banner) => ({
            src: banner.imagem,
          }));
        }
      } catch (error) {
        if (!localStorage.getItem("offLine")) {
          this.$eventbus.erro("Erro ao carregar banners");
        }
      }
    },
    async getCategorias() {
      const { data } = await Services.categorias();
      if (data) {
        const categorias = data.categorias.map((categoria) => ({
          id: categoria.id,
          nome: categoria.nome,
          src: require(`@/assets/images/categorias/${categoria.id}.png`),
        }));
        this.$store.commit("setCategorias", categorias);
      }
    },

    async getProdutos() {
      this.overlayFiltro = true;
      const parametros = {};
      parametros.paginacao = 18;

      parametros.fornecedor =
        (this.$auth && this.$auth.user && this.$auth.user.fornecedor_id) || "";

      if (this.filtro.pagina) {
        parametros.page = this.filtro.pagina;
      }
      if (this.filtro.categorias) {
        parametros.categorias = this.filtro.categorias.join(",");
      }
      if (this.filtro.termoPesquisa) {
        parametros.busca = this.filtro.termoPesquisa;
      }

      if (this.filtro.filtrarValores) {
        parametros.valor_minimo = this.filtro.valorInicial;
        parametros.valor_maximo = this.filtro.valorFinal;
      }

      if (this.filtro.fornecedor) {
        parametros.fornecedor = this.filtro.fornecedor;
      }

      if (this.filtro.ordenacao) {
        parametros.ordenacao = this.filtro.ordenacao;
      }

      try {
        const { data } = await ServiceProdutos.buscar(parametros);
        if (data) {
          this.produtos = data.produtos;
          this.page = data.produtos.current_page;
          this.totalPages = data.produtos.last_page;
          this.totalProdutos = data.produtos.total;
          window.scrollTo(0, 0);
        }
      } catch (error) {
        if (!localStorage.getItem("offLine")) {
          this.$eventbus.erro("Erro ao carregar produtos");
        }
      } finally {
        this.overlayFiltro = false;
      }
    },
  },
  watch: {
    "$store.state.filtro": {
      handler: function(filtro) {
        this.filtro.categorias = [...filtro.categorias];
        this.filtro.termoPesquisa = filtro.termoPesquisa;
        this.filtro.filtrarValores = filtro.filtrarValores;
        this.filtro.valorInicial = filtro.valorInicial;
        this.filtro.valorFinal = filtro.valorFinal;
        this.filtro.ordenacao = filtro.ordenacao;
        this.filtro.fornecedor =
          (filtro.fornecedor && filtro.fornecedor.id) || null;
        this.showBanners = false;
        this.novidades = false;
        this.getProdutos();
        this.getBanners();
      },
      deep: true,
    },
  },
};
</script>
